/** @jsxImportSource @emotion/react */
import React from 'react'

interface EditGameIconProps {
  size?: number
  color?: string
  className?: string
}

const EditGameIcon: React.FC<EditGameIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    className={className}
  >
    <path
      d='M2 11.6407V14.0007H4.35933L11.5267 6.83333L9.16733 4.474L2 11.6407ZM13.8053 4.55467C14.0653 4.29467 14.0653 3.87467 13.8053 3.61467L12.386 2.19533C12.126 1.93533 11.706 1.93533 11.446 2.19533L10.286 3.35533L12.6453 5.71467L13.8053 4.55467Z'
      fill={color}
    />
  </svg>
)

export default EditGameIcon
